import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchSlAdminAccounts = periodName => fetch(
  Config.endpoints.FETCH_SL_ADMIN_ACCOUNTS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching SL Admin Accounts failed' }))
  .then(parseAsJson);

export const importSlAdminAccounts = async (slAdminAccounts, periodName) => await fetch(
  Config.endpoints.ADMIN_IMPORT_SL_ADMIN_ACCOUNTS,
  {
    method: 'POST',
    body: JSON.stringify({ slAdminAccounts, periodName }),
  }
)
  .then(handleErrors({ errorMessage: 'Importing TLS Account failed' }));

export const fetchSlAccounts = periodName => fetch(
  Config.endpoints.FETCH_SL_ACCOUNTS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching SL Accounts failed' }))
  .then(parseAsJson);

export const fetchSlViews = () => fetch(
  Config.endpoints.FETCH_SL_VIEWS
)
  .then(handleErrors({ errorMessage: 'Fetching SL Views failed' }))
  .then(parseAsJson);
